// extracted by mini-css-extract-plugin
export default {"MailingForm":"MailingForm_MailingForm__UewNp","MailingForm__item":"MailingForm_MailingForm__item__Cv05k"};